export const METRICS = {
  per_day: { label: 'Pieces / day present', short: 'Pcs/day' },
  per_hour: { label: 'Pieces / hour on duty', short: 'Pcs/hr' },
  target_pct: { label: '% of target', short: '% Target' },
};

export const fmtVal = (v, metric) => {
  if (v == null) return '—';
  if (metric === 'target_pct') return `${Math.round(v)}%`;
  return Number(v).toLocaleString('en-IN', { maximumFractionDigits: 1 });
};

export const fmtQty = (v) => Number(v || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 });

export const fmtDay = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' }) : '');

export const istToday = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });

const monthStart = (iso, add) => {
  const [y, m] = iso.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1 + add, 1)).toISOString().slice(0, 10);
};

const fyStart = (iso) => {
  const y = Number(iso.slice(0, 4));
  return `${Number(iso.slice(5, 7)) >= 4 ? y : y - 1}-04-01`;
};

export const PRESETS = [
  { id: 'month', label: 'This month', range: (t) => [monthStart(t, 0), t] },
  { id: 'last3', label: 'Last 3 months', range: (t) => [monthStart(t, -2), t] },
  { id: 'fy', label: 'Since April', range: (t) => [fyStart(t), t] },
];

export const lowRuleText = (rule, pct) => (rule === 'target' ? 'below the operation target' : `below ${pct}% of the operation average`);
